export const TESTIMONIAL_TITLES = {
    'Client Success Story': true,
};

export const ERROR_CODE_CANCELED = 'ERR_CANCELED';
